"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRundownRowsText = void 0;
const getRundownRowsText = (rundownRows, schema) => {
    const resultStrings = [];
    const sortedRows = [...rundownRows].sort((r1, r2) => r1.sequence - r2.sequence);
    sortedRows.forEach((rundownRow) => {
        const { blobData } = rundownRow;
        schema.columns.forEach((column) => {
            if (column.rundownColumnType === 'text' ||
                column.rundownColumnType === 'longText') {
                const value = blobData[column.colId];
                if (typeof value === 'string' && value.length > 0) {
                    resultStrings.push(value);
                }
            }
        });
    });
    return resultStrings;
};
exports.getRundownRowsText = getRundownRowsText;
